<template>
  <div class="homepage header-donate">

    <div class="first-feature-product feature-product product-list" v-if="ready && firstFeatureProducts.length > 0">
      <div class="product-item" v-for="product in firstFeatureProducts" :key="product.sku">
        <product-list-item
          :product="product"
          :forceNoActions="true"
          :initialQuantity="1"
          :showTimeBeforeAvailable="true"
          :featureMode="true"
          extraClasses="product--inline product--fullwidth"></product-list-item>
      </div>
    </div> <!-- End Product Hilight -->

    <div class="second-feature-product feature-product product-list" v-if="ready  && secondFeatureProducts.length > 0">
      <div class="product-item" v-for="product in secondFeatureProducts" :key="product.sku">
        <product-list-item
          :product="product"
          :forceNoActions="true"
          :initialQuantity="1"
          :showTimeBeforeAvailable="true"
          :featureMode="true"
          extraClasses="product--inline product--fullwidth"></product-list-item>
      </div>
    </div> <!-- End Product Hilight -->

    <div class="third-feature-product feature-product product-list" v-if="ready  && thirdFeatureProducts.length > 0">
      <div class="product-item" v-for="product in thirdFeatureProducts" :key="product.sku">
        <product-list-item
          :product="product"
          :forceNoActions="true"
          :initialQuantity="1"
          :showTimeBeforeAvailable="true"
          :featureMode="true"
          extraClasses="product--inline product--fullwidth"></product-list-item>
      </div>
    </div> <!-- End Product Hilight -->

    <div class="homepage__wrapper">
      <div class="container">
        <div class="row all-product product-list flex" v-if="ready">
          <div class="col-sm-4 flex" v-for="product in activeProducts" :key="product.sku">
            <product-list-item
              :product="product"
              :forceNoActions="true"
              :initialQuantity="1"
              :showTimeBeforeAvailable="true"
              :showAttributes="true"
              extraClasses="product--card"></product-list-item>
          </div>
        </div>
        <!-- sold out -->
        <div v-if="ready && soldoutProducts.length > 0" class="mt-30">
          <h2>Sold Out</h2>
          <div class="row homepage__wrapper product-list flex">
            <div class="col-sm-4 flex" v-for="product in soldoutProducts" :key="product.sku">
              <product-list-item
                :product="product"
                :forceNoActions="true"
                :initialQuantity="1"
                :showTimeBeforeAvailable="true"
                extraClasses="product--card"></product-list-item>
            </div>
          </div>
        </div><!-- /sold out -->
      </div>
    </div>

    <!-- <div class="block text-center mb-40">
      <a href="#/" class="btn btn--white btn-md">ดูหนังสือทั้งหมด</a>
    </div> -->

    <div class="block" v-if="!ready">
      <loader></loader>
    </div>
    <!-- </div> -->
    <!-- </div>  -->
    <!-- product hilight -->

  </div>
</template>

<style lang="scss">



  //
  // .product-hilight {
  //   background: #fff;
  //   text-align: center;
  //   > .col-1 {
  //
  //     background: #9D9D9D;
  //     margin-bottom: 10px;
  //
  //     .product--inline .product__image {
  //       order: 2;
  //       background: transparent;
  //     }
  //     .product--inline .product__block--form {
  //       justify-content: center;
  //     }
  //     .product--inline .product__wrapper { flex: 0; }
  //
  //   }
  //
  //   > .col-2 {
  //
  //     .flex:first-child {
  //       background: #7B8E71;
  //     }
  //     .flex:last-child {
  //       background: #DCDCDC;
  //       border-left: 10px solid #fff;
  //     }
  //
  //     .product--card {
  //       border: none;
  //       background: none;
  //       .product__image { background: transparent;}
  //       // .product__image { order: 2;}
  //     }
  //   }
  // }


</style>

<script>
  import ProductListItem from './ProductListItem.vue'
  import Loader from './Loader.vue'

  export default {
    components: {
      Loader,
      ProductListItem
    },
    name: 'Homepage',
    data () {
      return {
        products: [],
        ready: false
      }
    },
    created () {
      const productSku = process.env.MAIN_PRODUCT_SKU
      this.$http.get(`products/${productSku}`)
        .then(resp => {
          if (this.$utils.isProductAvailable(resp.body)) {
            this.$router.push(`/${productSku}`)
          } else {
            window.location = process.env.MAIN_WEBSITE_URL
          }
        })
        .catch(err => {
          console.log(err)
          window.location = process.env.MAIN_WEBSITE_URL
        })
    },
    computed: {
      firstFeatureProducts () {
        return (this.products || []).filter(item => item.featured && item.weight > 100000)
      },
      secondFeatureProducts () {
        return (this.products || []).filter(item => item.featured && item.weight > 10000 && item.weight <= 100000)
      },
      thirdFeatureProducts () {
        return (this.products || []).filter(item => item.featured && item.weight > 1000 && item.weight <= 10000)
      },
      activeProducts () {
        return (this.products || []).filter(item => !item.featured) // This site include sold out
        // return (this.products || []).filter(item => !item.featured && item.flags ^ 1)
      },
      soldoutProducts () {
        return [] // This site include sold out
        // return (this.products || []).filter(item => !item.featured && item.flags & 1)
      }
    },
    methods: {
      fetch () {
        this.$store.dispatch('syncProducts')
          .then(products => {
            this.products = (products || []).filter(item => item.listed)
            this.ready = true
          })
          .catch(err => {
            console.log(err)
            this.$utils.showCommonError()
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Homepage.vue?482502f4